import { policyPlugin } from './plugin';

export default policyPlugin;
